import { render, staticRenderFns } from "./PercentField.vue?vue&type=template&id=0b8972f3&lang=pug&"
import script from "./PercentField.vue?vue&type=script&lang=js&"
export * from "./PercentField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b8972f3')) {
      api.createRecord('0b8972f3', component.options)
    } else {
      api.reload('0b8972f3', component.options)
    }
    module.hot.accept("./PercentField.vue?vue&type=template&id=0b8972f3&lang=pug&", function () {
      api.rerender('0b8972f3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/fields/PercentField.vue"
export default component.exports